/* eslint-disable local/no-nested-selectors */
import { Theme } from "@remo-co/ui-core/src/types";
import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";

export const useStyles = makeStyles<Theme>(() => ({
  pdpBox: {
    textAlign: "left",
    "& ul": {
      fontSize: "1rem",
      fontWeight: "bold",
      color: "var(--TextDark)",
    },

    "& .MuiBox-root": {
      marginTop: "1rem",

      " &:last-child": {
        marginBottom: "1rem",
      },
    },
  },
}));
